import {
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
  Divider,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { EditableHotkey } from "../EditableHotkey";

export const OtherFunctionalityGuide = () => {
  const { t } = useTenantTranslation();

  return (
    <Stack spacing={3}>
      <Typography variant="h6">{t("otherFunctionalityTitle")}</Typography>

      <Box>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t("hotkeyReference")}
        </Typography>
        <Typography variant="body2" fontStyle="italic" gutterBottom>
          {t("hotkeyReferenceDescription")}
        </Typography>

        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>{t("hotkey")}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t("action")}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="liftEvent" />
                </TableCell>
                <TableCell>{t("recordLift")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="dropEvent" />
                </TableCell>
                <TableCell>{t("recordDrop")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="addFlag" />
                </TableCell>
                <TableCell>{t("addFlag")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="deleteEvent" />
                </TableCell>
                <TableCell>{t("deleteSelectedEvent")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="unknownMaterial" />
                </TableCell>
                <TableCell>{t("markAsUnknownMaterial")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="reverseLiftDrop" />
                </TableCell>
                <TableCell>{t("reverseLiftDrop")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <EditableHotkey hotkeyId="playPause" />
                </TableCell>
                <TableCell>{t("playPauseVideo")}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Stack direction="row" spacing={0.5}>
                    <EditableHotkey hotkeyId="rewindLeft" />
                    <Typography>/</Typography>
                    <EditableHotkey hotkeyId="forwardRight" />
                  </Stack>
                </TableCell>
                <TableCell>{t("navigateVideoTimeline")}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Divider />

      <Box>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t("reverseLiftDropFeature")}
        </Typography>
        <Typography variant="body2">
          {t("reverseLiftDropExplanation")}
        </Typography>
      </Box>

      <Divider />

      <Box>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t("editEventPanelTitle")}
        </Typography>
        <Typography variant="body2" mb={1}>
          {t("editEventPanelDescription")}
        </Typography>
        <Typography variant="body2" component="div">
          <strong>{t("exampleUseCases")}:</strong>
          <ul style={{ margin: "0.5rem 0", paddingLeft: "1.5rem" }}>
            <li>{t("commentUseCase1")}</li>
            <li>{t("commentUseCase2")}</li>
            <li>{t("commentUseCase3")}</li>
          </ul>
        </Typography>
      </Box>

      <Divider />

      <Box>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {t("addFlagFeature")}
        </Typography>
        <Typography variant="body2" mb={1}>
          {t("addFlagExplanation")}
        </Typography>
      </Box>

      <Divider />

      <Alert severity="warning">
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          {t("unknownMaterialTitle")}
        </Typography>
        <Typography variant="body2">{t("unknownMaterialGuidance")}</Typography>
      </Alert>
    </Stack>
  );
};
